import { gql } from "@apollo/client";
import { GetPatientDataImportQuery } from "~/graphql/__generated__/graphql";

// All the duplication in the file is terrible
// but trying to dynamically construct these out
// of templates with the correct details interpolated
// doesn't seem to work with graphql-codegen.

export const CREATE_PATIENT_DATA_IMPORT = gql(`
  mutation CreatePatientDataImport(
    $filename: String!
  ) @permission(requires: importPatients) {
    createDataImport(
      resourceType: patient
      filename: $filename
    ) {
      dataImport {
        id
        filePathToS3
        filename
        status
      }
      fileUploadUrl
    }
  }
`);

export const CREATE_USER_DATA_IMPORT = gql(`
  mutation CreateUserDataImport(
    $filename: String!
  ) @permission(requires: importUsers) {
    createDataImport(
      resourceType: user
      filename: $filename
    ) {
      dataImport {
        id
        filePathToS3
        filename
        status
      }
      fileUploadUrl
    }
  }
`);

export const GET_PATIENT_DATA_IMPORT_PREVIEW = gql(`
  query GetPatientDataImportPreview($dataImportId: Int!) @permission(requires: importPatients) {
    dataImportPreview(
      dataImportId: $dataImportId
      resourceType: patient
    ) {
      columnNames
      csvColumnNames
      preview {
        validRecordCount
        totalErrorCount
        errors {
          csvRow 
          rowIndex
          errors {
            instancePath
            keyword
            message
          }
        }
        exampleRecords {
          record 
          rowIndex
        }
      }
    }
  }
`);

export const GET_USER_DATA_IMPORT_PREVIEW = gql(`
  query GetUserDataImportPreview($dataImportId: Int!) @permission(requires: importUsers) {
    dataImportPreview(
      dataImportId: $dataImportId
      resourceType: user
    ) {
      columnNames
      csvColumnNames
      preview {
        validRecordCount
        totalErrorCount
        errors {
          csvRow 
          rowIndex
          errors {
            instancePath
            keyword
            message
          }
        }
        exampleRecords {
          record 
          rowIndex
        }
      }
    }
  }
`);

export const EXECUTE_PATIENT_DATA_IMPORT = gql(`
  mutation ExecutePatientDataImport(
    $dataImportId: Int!
  ) @permission(requires: importPatients) {
    importData(
      resourceType: patient
      dataImportId: $dataImportId
    ) {
      id
    }
  }
`);

export const EXECUTE_USER_DATA_IMPORT = gql(`
  mutation ExecuteUserDataImport(
    $dataImportId: Int!
  ) @permission(requires: importUsers) {
    importData(
      resourceType: user
      dataImportId: $dataImportId
    ) {
      id
    }
  }
`);

export const DELETE_PATIENT_DATA_IMPORT = gql(`
  mutation DeletePatientDataImport(
    $dataImportId: Int!
  ) @permission(requires: importPatients) {
    deleteDataImport(
      resourceType: patient
      dataImportId: $dataImportId
    ) {
      id
    }
  }
`);

export const DELETE_USER_DATA_IMPORT = gql(`
  mutation DeleteUserDataImport(
    $dataImportId: Int!
  ) @permission(requires: importUsers) {
    deleteDataImport(
      resourceType: user
      dataImportId: $dataImportId
    ) {
      id
    }
  }
`);

export const GET_PATIENT_DATA_IMPORT = gql(`
  query GetPatientDataImport @permission(requires: importPatients) {
    dataImport(
      where: { resourceType: { eq: "patient" } }
      orderBy: {
        createdAt: { direction: desc, priority: 1 }
      }
    ) {
      id
      createdAt
      createdBy {
        firstName
        lastName
      }
      deleted
      filePathToS3
      metadata
      filename
      organizationId
      resourceType
      status
      updatedAt
    }
  }
`);

export const GET_USER_DATA_IMPORT = gql(`
  query GetUserDataImport @permission(requires: importUsers) {
    dataImport(
      where: { resourceType: { eq: "user" } }
      orderBy: {
        createdAt: { direction: desc, priority: 1 }
      }
    ) {
      id
      createdAt
      createdBy {
        firstName
        lastName
      }
      deleted
      filePathToS3
      metadata
      filename
      organizationId
      resourceType
      status
      updatedAt
    }
  }
`);

export type CustomDataImportSelectItem = GetPatientDataImportQuery['dataImport'][number]
